import {Component, OnDestroy, OnInit} from '@angular/core';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {ConclusionPagesService} from '../services/conclusion-pages/conclusion-pages.service';
import {AjaxDownloadQueueItem, AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {map} from 'rxjs/operators';
import {RoutesStorage} from '@helpers/routes.helper';
import {combineLatest} from 'rxjs';
import {Conclusion} from '@namespaces/conclusion.namespace';

@Component({
    selector: 'app-conclusion-list',
    templateUrl: './conclusion-list.component.html',
})
export class ConclusionListComponent extends ListItemsComponent<ConclusionPagesService> implements OnInit, OnDestroy {
    public objectsRoute = RoutesStorage.WorkingObject.list;

    constructor(
        listService: ConclusionPagesService,
        private ajaxDownloadService: AjaxDownloadService,
        private conclusionApiService: ConclusionApiService,
    ) {
        super(listService);
    }

    public documentsQueue$: AjaxDownloadQueueItem;

    public permissions = UserNamespace.Permission;

    public isBlankFilterActive = true;

    ngOnInit(): void {
        super.ngOnInit();
        this.service.filters$.pipe(
            untilDestroyed(this),
            map((value) => Boolean(value && value.conclusion_is_blank))
        ).subscribe((isBlankFilter: boolean) => {
            this.isBlankFilterActive = isBlankFilter;
        });
    }

    selectPageValues() {
        const items = this.service.items$.getValue();
        const currentValues = this.selectedValues$.getValue();

        if (items && items.length) {
            const ids: number[] = items.filter(item => !currentValues.includes(item.id) &&
                this.isItemAllowedToSelect(item)).map(item => item.id);
            this.selectedValues$.next(currentValues.concat(ids));
        }
    }

    generateConclusionDocuments() {
        this.documentsQueue$ = this.ajaxDownloadService.do({
            url: this.conclusionApiService.generateConclusionDocumentUrl,
            currentQueue: this.documentsQueue$,
            method: 'post',
            taskName: 'Заключения',
            data: {
                ids: this.selectedValues$.getValue()
            }
        });
    }
    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public isItemAllowedToSelect(item: Conclusion.ListViewItem): boolean {
        return item.with_inspections;
    }

    protected trackSelectedItems() {
        combineLatest([
            this.listService.items$.pipe(
                map(items => items.filter(item => this.isItemAllowedToSelect(item)))
            ),
            this.selectedValues$,
        ]).pipe(
            map((value: [{id: number}[], number[]]) => this.isCurrentItemsSelected(...value)),
            untilDestroyed(this),
        ).subscribe((v) => this.isCurrentItemsSelected$.next(v));
    }

}
